import Image from 'next/image';
import React, { useState } from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { styled } from 'styled-components';
import { BlogCity } from '../../../../pages/blog';

// Install Swiper modules
SwiperCore.use([Navigation]);

interface SearchAndFilterBlogsProps {
  title: string;
  searchQuery: string;
  handleInputChange: (e: any) => void;
  sliderCategories: BlogCity[];
  onCityChange: (newCityId: string) => void;
}

interface StyledSwiperProps {
  isfirstslide: string;
  isLastSlide: string;
}

const StyledSwiper = styled(Swiper)<StyledSwiperProps>`
  width: auto !important;
  height: 32px;

  .swiper {
    width: auto !important;
  }
  .swiper-slide {
    width: auto !important;
    display: flex;
    align-items: center;
  }
  .swiper-wrapper {
    display: flex !important;

    margin-left: ${props => (props.isfirstslide == 'true' ? `50px` : '0px')};
    margin-right: ${props => (props.isLastSlide == 'true' ? `50px` : '50px')};
    @media (max-width: 767px) {
      margin-left: ${props => (props.isfirstslide == 'true' ? `40px` : '0px')};
    }
  }
  .swiper-button-prev:after,
  .swiper-rtl .swiper-button-next:after {
    display: none;
  }

  .swiper-button-prev {
    left: 0px !important;
  }
  .swiper-button-next:after,
  .swiper-rtl .swiper-button-prev:after {
    display: none;
  }

  .swiper-button-next {
    right: 0px !important;
  }
`;

export default function SearchAndFilterBlogs({
  title,
  searchQuery,
  handleInputChange,
  sliderCategories,
  onCityChange
}: SearchAndFilterBlogsProps) {
  const [selectedCategory, setSelectedCategory] = useState('all-blogs');
  const [activeIndex, setActiveIndex] = useState(0);

  const handleCategoryClick = (cityId: string) => {
    setSelectedCategory(cityId);
    onCityChange(cityId);
  };

  const handleSlideChange = (swiper: any) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div className="flex flex-col gap-6 sm:gap-8">
      <div
        className="flex sm:justify-between flex-col sm:flex-row gap-6 sm:gap-0 sm:items-center"
        id="search"
      >
        <h2 className="text-black2 text-xl md:text-[26px] 2xl:text-3xl 3xl:text-4xl font-semibold">
          {title}
        </h2>
        {/*  commenting for later implementation
        <div className="rounded-[30px] flex border border-[#e0e0e0] justify-between items-center py-1.5 2xl:py-[0.4rem] 3xl:py-2.5 px-4 w-full sm:w-[285px]">
          <input
            className="rounded-[30px] bg-grayFA px-1 placeholder:text-[#9e9e9e] text-black2 text-sm sm:text-base font-normal leading-7 tracking-wide focus:outline-none"
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleInputChange}
          />
          <Image
            height={24}
            width={24}
            src="/lightGray-search-icon.svg"
            alt="search-normal"
            className={`w-5 h-5 cursor-pointer transition-all duration-300 ease-in-out`}
          />
        </div> */}
      </div>
      <div id="filter">
        <StyledSwiper
          slidesPerView={10}
          spaceBetween={25}
          grabCursor
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }}
          onSlideChange={handleSlideChange}
          isfirstslide={(activeIndex === 0).toString()}
          isLastSlide={(activeIndex === sliderCategories.length - 1).toString()}
          breakpoints={{
            320: { slidesPerView: 3.28 },
            340: { slidesPerView: 3.48 },
            360: { slidesPerView: 3.67 },
            375: { slidesPerView: 3.82 },
            390: { slidesPerView: 3.96 },
            414: { slidesPerView: 4.15 },
            425: { slidesPerView: 3.83 },
            540: { slidesPerView: 4.8 },
            640: { slidesPerView: 5 },
            768: { slidesPerView: 5.74 },
            1024: { slidesPerView: 7.84 },
            1280: { slidesPerView: 9.4 },
            1440: { slidesPerView: 10.5 },
            1536: { slidesPerView: 10.6 },
            1700: { slidesPerView: 11.7 },
            1800: { slidesPerView: 13 },
            1920: { slidesPerView: 14 },
            2200: { slidesPerView: 16 }
          }}
          className="custom-swiper"
        >
          {sliderCategories
            ?.filter(city => city !== null)
            .map((city, index) => (
              <SwiperSlide
                key={index}
                onClick={() => handleCategoryClick(city.id)}
              >
                <div
                  className={`flex flex-col items-center justify-between cursor-pointer border-b-2 border-solid ${
                    selectedCategory === city.id
                      ? 'border-primary text-primary'
                      : 'border-transparent text-black'
                  }`}
                >
                  <p className="text-xs msm:text-sm sm:text-base font-normal whitespace-nowrap leading-7 tracking-wide">
                    {city.name}
                  </p>
                </div>
              </SwiperSlide>
            ))}

          <div
            className={`flex w-[2.5rem] h-[4.15rem] bg-white justify-start  absolute z-20 cursor-pointer swiper-button-prev items-center left-0 
      top-0`}
          >
            <Image
              src={
                activeIndex === 0
                  ? '/gray-circled-left-arrow.svg'
                  : '/red-circled-left-arrow.svg'
              }
              alt="left-icon"
              width={50}
              height={50}
              className="w-8 h-8 md:w-12 md:h-12"
              priority={true}
            />
          </div>
          <div
            className={`flex w-[2.5rem] h-[4.15rem] bg-white justify-end absolute z-20 cursor-pointer swiper-button-next items-center right-0`}
          >
            <Image
              src={
                activeIndex === sliderCategories?.length - 1
                  ? '/gray-circled-right-arrow.svg'
                  : '/red-circled-right-arrow.svg'
              }
              alt="right-icon"
              width={50}
              height={50}
              className="w-8 h-8 md:w-12 md:h-12"
              priority={true}
            />
          </div>
        </StyledSwiper>
      </div>
    </div>
  );
}
